// ================================================================
// Platform API client — فقط برای کاربرِ platform (محمد/LevelUpAi)
// ================================================================
import { apiRequest } from './apiClient.js';

export function listOrgs() {
  return apiRequest('/api/platform/orgs');
}
export function createOrg(data) {
  return apiRequest('/api/platform/orgs', { method: 'POST', body: JSON.stringify(data) });
}
export function getOrg(id) {
  return apiRequest('/api/platform/orgs/' + encodeURIComponent(id));
}
export function setOrgStatus(id, status) {
  return apiRequest('/api/platform/orgs/' + encodeURIComponent(id) + '/status', {
    method: 'PATCH',
    body: JSON.stringify({ status }),
  });
}
export function getOrgAudit(id) {
  return apiRequest('/api/platform/orgs/' + encodeURIComponent(id) + '/audit');
}
// Plan/Module (Entitlements) — لیست خالی = همه‌ی ماژول‌ها
export function setOrgModules(id, enabledModules) {
  return apiRequest('/api/platform/orgs/' + encodeURIComponent(id) + '/modules', {
    method: 'PATCH',
    body: JSON.stringify({ enabledModules }),
  });
}

// Mitglied für eine Kunden-Firma einladen → { invitation, inviteUrl }
export function inviteOrgMember(id, { email, roleId }) {
  return apiRequest('/api/platform/orgs/' + encodeURIComponent(id) + '/invitations', {
    method: 'POST',
    body: JSON.stringify({ email, roleId: roleId || null }),
  });
}

// Wie viele Geräte dürfen GLEICHZEITIG angemeldet sein (docs/ein-geraet-pro-konto.md).
// 1 = der Normalfall «ein Konto, ein Gerät». Höher für Demo-/Vertriebskonten,
// an denen mehrere Leute hängen.
export function setOrgMaxSessions(id, maxSessions) {
  return apiRequest('/api/platform/orgs/' + encodeURIComponent(id) + '/max-sessions', {
    method: 'PATCH',
    body: JSON.stringify({ maxSessions }),
  });
}

// Dauerzugang: diese Firma wird nie wegen des Abos gesperrt (Demo-Konten).
export function setOrgSubscriptionExempt(id, exempt) {
  return apiRequest('/api/platform/orgs/' + encodeURIComponent(id) + '/subscription-exempt', {
    method: 'PATCH',
    body: JSON.stringify({ exempt }),
  });
}

// KI-Teil der Ausschreibungs-Prüfung (Pilot): freischalten; die Firma willigt danach selbst ein.
export function setOrgTenderAuditAi(id, enabled) {
  return apiRequest('/api/platform/orgs/' + encodeURIComponent(id) + '/tender-audit-ai', {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });
}

// ── سطل آشغال (trash) ──
export function deleteOrg(id) {
  return apiRequest('/api/platform/orgs/' + encodeURIComponent(id), { method: 'DELETE' });
}
export function listTrash() {
  return apiRequest('/api/platform/orgs/trash');
}
export function restoreOrg(id) {
  return apiRequest('/api/platform/orgs/' + encodeURIComponent(id) + '/restore', { method: 'POST' });
}
export function purgeOrg(id) {
  return apiRequest('/api/platform/orgs/' + encodeURIComponent(id) + '/permanent', { method: 'DELETE' });
}
